import { listingCategories, listingCategoryLabel } from "../data/listingCategories";

function CreateListingPage({
  description = "Udfyld oplysningerne, gennemgå annoncen, og publicer den, når du er klar.",
  error,
  form,
  heading = "Opret annonce",
  imagePreviewUrls = [],
  isCreatingDraftFromImage = false,
  isSubmitting,
  onCancel,
  onChange,
  onCreateDraftFromImage,
  onImageChange,
  onRemoveImage,
  onSubmit,
  submitLabel = "Publicer annonce",
  submittingLabel = "Gemmer...",
}) {
  return (
    <section className="main-panel">
      <div className="page-heading">
        <div>
          <span className="mini-label">Ny annonce</span>
          <h1>{heading}</h1>
          <p>{description}</p>
        </div>
        <button className="secondary-action page-action" onClick={onCancel} type="button">
          Tilbage
        </button>
      </div>

      <form className="listing-form" onSubmit={onSubmit}>
        <div className="listing-form-grid">
          <div className="listing-image-picker">
            <label className="image-drop create-image-drop">
              {imagePreviewUrls.length ? (
                <img src={imagePreviewUrls[0]} alt="Første valgte annoncebillede" />
              ) : (
              <div>
                <span>+</span>
                <strong>Tilføj billeder</strong>
                <p>Valgfrit nu, men anbefalet for bedre søgning.</p>
              </div>
              )}
              <input type="file" accept="image/*" multiple onChange={onImageChange} />
            </label>
            {imagePreviewUrls.length > 0 && (
              <div className="selected-listing-images">
                <div className="selected-listing-images-heading">
                  <strong>{imagePreviewUrls.length} {imagePreviewUrls.length === 1 ? "billede" : "billeder"}</strong>
                  <span>Det første billede bliver forsidebilledet</span>
                </div>
                <div className="selected-listing-image-grid">
                  {imagePreviewUrls.map((url, index) => (
                    <div className="selected-listing-image" key={`${url}-${index}`}>
                      <img src={url} alt={`Valgt annoncebillede ${index + 1}`} />
                      {index === 0 && <span>Forside</span>}
                      {onRemoveImage && (
                        <button
                          aria-label={`Fjern billede ${index + 1}`}
                          onClick={() => onRemoveImage(index)}
                          type="button"
                        >
                          ×
                        </button>
                      )}
                    </div>
                  ))}
                </div>
                <label className="secondary-action add-more-images">
                  Tilføj andre billeder
                  <input type="file" accept="image/*" multiple onChange={onImageChange} />
                </label>
              </div>
            )}
          </div>

          <div className="ai-draft-card">
            <span className="mini-label">AI-assistent</span>
            <h2>Udfyld fra billede</h2>
            <p>
              Lad AI foreslå titel, kategori og beskrivelse. Intet gemmes, før du selv
              publicerer annoncen.
            </p>
            {onCreateDraftFromImage && (
              <button
                className="secondary-action"
                disabled={isCreatingDraftFromImage || !imagePreviewUrls.length}
                onClick={onCreateDraftFromImage}
                type="button"
              >
                {isCreatingDraftFromImage ? "Analyserer..." : "Udfyld med AI"}
              </button>
            )}
          </div>

          <div className="listing-fields">
            <label>
              Annoncetype
              <select name="tradeMode" value={form.tradeMode || "sale"} onChange={onChange}>
                <option value="sale">Til salg</option>
                <option value="trade">Til bytte</option>
                <option value="both">Salg eller bytte</option>
              </select>
            </label>
            {["trade", "both"].includes(form.tradeMode) && (
              <label>
                Hvad vil du gerne bytte til?
                <textarea name="tradeWishes" value={form.tradeWishes || ""} onChange={onChange}
                  maxLength={500} rows={2} placeholder="Fx en Nintendo Switch — eller kom med et forslag" />
              </label>
            )}
            <label>
              Titel
              <input
                name="title"
                onChange={onChange}
                placeholder="Spisebordsstol i eg"
                required
                value={form.title}
              />
            </label>

            <label>
              Beskrivelse
              <textarea
                name="description"
                onChange={onChange}
                placeholder="Kort, konkret beskrivelse af varen..."
                rows="5"
                value={form.description}
              />
            </label>

            <div className="field-row">
              <label>
                Kategori
                <select name="category" onChange={onChange} required value={form.category}>
                  <option value="">Vælg kategori</option>
                  {listingCategories.map((category) => (
                    <option key={category} value={category}>{listingCategoryLabel(category)}</option>
                  ))}
                </select>
              </label>

              <label>
                Stand
                <input
                  name="condition"
                  onChange={onChange}
                  placeholder="God"
                  value={form.condition}
                />
              </label>
            </div>

            <div className="field-row">
              <label>
                {form.tradeMode === "trade" ? "Værdi i kr. (valgfri)" : "Pris"}
                <input
                  min="0"
                  name="priceAmount"
                  onChange={onChange}
                  required={form.tradeMode !== "trade"}
                  type="number"
                  value={form.priceAmount}
                />
              </label>

              <label>
                Lokation
                <input
                  name="location"
                  onChange={onChange}
                  placeholder="København"
                  value={form.location}
                />
              </label>
            </div>

            <button className="primary-action" disabled={isSubmitting} type="submit">
              {isSubmitting ? submittingLabel : submitLabel}
            </button>
            {error && <p className="status-line error">{error}</p>}
          </div>
        </div>
      </form>
    </section>
  );
}

export default CreateListingPage;
